export function Header() {
    return {
        headers: {
            'Content-Type': 'application/json',
            // "Content-Type": "multipart/form-data",
            // "Accept": "application/json",
            // "type": "formData",
        }
    }
}

export function HeaderFormData() {
    return {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }
}

export function HeaderPoli() {
    return {
        headers: {
            'Content-Type': 'application/json',
        }
    }
}